import { type OptimizelyDecision } from '@optimizely/react-sdk';
import { type PerksList } from '@fff-web/fff-ui-shared/Plans';
import { IPlanCode, IPromoCode } from '../../Interfaces';

export interface IProductsList
  extends Array<{
    imagePublicId: string;
    title: string;
    caption: string;
  }> {}

export interface IReactivateMembershipContext extends OptimizelyDecision {
  variables: {
    planSectionSubtitle: string;
    planSectionTitle: string;
    seasonalPerks: {
      list: PerksList;
    };
    annualPerks: {
      list: PerksList;
    };
    heroBanner: {
      headline: string;
      caption: string;
      disclaimer: string;
      mainCTA: string;
    };
    howItWorks: {
      headline: string;
      productsList: IProductsList;
    };
    seasonMembershipName: string;
    increasedPrice: number;
    annualCardSubtitle:string
  };
}

export type MyMembershipContextType = {
  btnContainerRef: any;
  growthMyMembership: OptimizelyDecision;
  setPlanCode: (planCode: IPlanCode) => void;
  selectedPlanCode: IPlanCode;
  couponsApplied: IPromoCode[];
  setCouponsApplied: React.Dispatch<React.SetStateAction<IPromoCode[]>>;
  myAccountPath?: string;
  showReactivationContent: boolean;
};

export const initialStateDecision: OptimizelyDecision = {
  variationKey: null,
  userContext: {
    id: null,
    attributes: undefined,
  },
  enabled: false,
  variables: {},
  ruleKey: null,
  flagKey: '',
  reasons: [],
};

const defaultReactivateMyMembershipContext: MyMembershipContextType = {
  btnContainerRef: null,
  growthMyMembership: initialStateDecision,
  setPlanCode: () => {},
  selectedPlanCode: undefined,
  couponsApplied: [],
  setCouponsApplied: () => { },
  showReactivationContent: false,
};

export default defaultReactivateMyMembershipContext;
